import { Required, DataValidator, IsArray, IsString } from "@/utils/type-vaildator";
import api from "./api";

export interface GenerateSora2ImageToVodRequest {
  agentId: string;
  fileUrl?: string;
  text: string;
  level?: string;
  model: string;
  duration?: number;
  aspectRatio?: string;
  type: number;
  imageSize?: string;
}

class MakeGenerateResponseRaw {
  @Required("taskIds cannot be empty")
  @IsString("taskIds must be a string")
  taskIds: string;
}

// 生成 Sora2 视频(图生视频)
export const generateSora2ImageToVod = async ({
  agentId,
  text,
  type,
  model,
  duration,
  aspectRatio,
  level,
  fileUrl,
  imageSize,
}: GenerateSora2ImageToVodRequest): Promise<string> => {
  const res = await api.post<MakeGenerateResponseRaw>("/sj/sora2/img2vod/create", {
    agent_id: agentId,
    prompt: text,
    level: level,
    model,
    duration,
    aspectRatio,
    fileUrl,
    type,
    imageSize,
    resolution: imageSize,
  });
  const root = res.data;
  const validated = DataValidator.validateOrThrow(root, MakeGenerateResponseRaw);
  return validated.taskIds;
};
